import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from '../utils/history';
import languageReducer from '../screens/language/reducer'
import idProofReducer from '../screens/idProof/reducer'
import idPhotoReducer from '../screens/idPhoto/reducer'
import addressProofReducer from '../screens/addressProof/reducer'
import selfieReducer from '../screens/selfie/reducer'
import homeImageReducer from '../screens/homeImage/reducer'
import videoReducer from '../screens/video/reducer'
import sharedReducer from '../shared/reducer'
import LoaderReducer from '../shared/ActivityLoader/reducer'

const appReducer = combineReducers({
  router: connectRouter(history),
  language: languageReducer,
  idProof: idProofReducer,
  idPhoto: idPhotoReducer,
  addressProof: addressProofReducer,
  selfie: selfieReducer,
  homeImage: homeImageReducer,
  video: videoReducer,
  shared: sharedReducer,
  loader: LoaderReducer
});

const rootReducer = (state, action) => {
  return appReducer(state, action)
}

export default rootReducer

